var _a;
import { __decorate, __metadata } from "tslib";
// Sprint 4 / P23 — Vuex module do dashboard executivo do MTZ.
// Endpoint único agregando cobertura, gap, treinamentos e presença.
import mtzService from "@/core/services/mtzService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { DashboardMTZActions } from "@/store/enums/mtzEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let DashboardMTZModule = class DashboardMTZModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = DashboardMTZActions.GET_INDICADORES_MTZ]() {
        return new Promise((resolve, reject) => {
            mtzService.get("DashboardMTZ/Indicadores", "")
                .then(({ data }) => {
                resolve(data);
            })
                .catch((error) => {
                if (error === null || error === void 0 ? void 0 : error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao buscar indicadores do dashboard.");
                }
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DashboardMTZModule.prototype, _a, null);
DashboardMTZModule = __decorate([
    Module
], DashboardMTZModule);
export default DashboardMTZModule;
//# sourceMappingURL=DashboardMTZModule.js.map